import React from "react";
import {MenuItem, TextField} from "@mui/material";
import {DEFAULT_PRODUCT_CODE_SPLITTER, PRODUCT_CODE_SPLITTER_LIST} from "./constants";

const ProductCodeSplitterSelect = ({
                                       value,
                                       onChange,
                                       disabled = false,
                                       loading = false,
                                       label = 'Splitter',
                                       sx,
                                   }) => (
    <TextField
        select
        label={label}
        variant={'outlined'}
        size={'small'}
        disabled={disabled || loading}
        sx={{minWidth: 220, ...sx}}
        SelectProps={{
            renderValue: (selected) =>
                PRODUCT_CODE_SPLITTER_LIST.find((entry) => entry.value === selected)?.title
                ?? 'Select Splitter',
            displayEmpty: true,
        }}
        value={value ?? DEFAULT_PRODUCT_CODE_SPLITTER}
        onChange={onChange}
    >
        {PRODUCT_CODE_SPLITTER_LIST.map((entry) => (
            <MenuItem key={entry.value} value={entry.value}>
                {entry.title}
            </MenuItem>
        ))}
    </TextField>
);

export default ProductCodeSplitterSelect;
